<template>
  <div class="d-flex align-center jobs-overview-scroll-menu">
    <strong>{{ numJobs }} {{ $tc('jobs.joboffers', numJobs) }}</strong>
    <span class="ml-auto">
      <jobalert-dialog></jobalert-dialog>
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import jobalertDialog from '@/components/jobalert/signup-dialog.vue';

export default {
  computed: {
    ...mapGetters('jobsModule', {
      joboffers: 'getJoboffers'
    }),

    ...mapState('companyModule', {
      showBlacklistedJoboffers: 'showBlacklistedJoboffers'
    }),

    visibleJoboffers() {
      return this.joboffers.filter(
        (x) => this.showBlacklistedJoboffers || !x.isBlacklisted
      );
    },

    numJobs() {
      return this.visibleJoboffers.length;
    }
  },

  components: {
    jobalertDialog
  }
};
</script>
